﻿export interface ISubmission {
    id: string;
    policyholderId: string;
    offeringId: string;
    statusCId: string;
    policyEffectiveDate: Date;
    policyExpirationDate: Date;
    currentlyInsured: boolean;
    yearEstablished: number;
    businessTypeCId: string;
    officersCovered: boolean;
    payrollIncludesOfficers: boolean;
    independentContractorsUsageCId: string;
    leasedEmployeeUsageCId: string;
    sicCode: number;
    classCodeCrime: string;
    retroactiveDateEpl: Date;
    fein: string;
    legalBusinessName: string;
    doingBusinessAs: string;
    ncciRiskId: string;
    controllingTaxAddressId: string;
    ownedVehicles: boolean;
    experienceModifierNcci: number;
    experienceModifierWcirb: number;
    experienceModifierDcrb: number;
    experienceModifierCaom: number;
    experienceModifierMwcia: number;
    experienceModifierNjcrib: number;
    experienceModifierNycirb: number;
    experienceModifierNcrb: number;
    experienceModifierPcrb: number;
    experienceModifierWcrb: number;
    hazardGradeUmbrellaCId: string;
    hazardGradeCyberCId: string;
    scheduleModifierDeliveryAuto: number;
    scheduleModifierLiability: number;
    scheduleModifierProperty: number;
    scheduleModifierUmbrella: number;
    scheduleModifierWorkersComp: number;
    ratingTierFactorLiability: number;
    ratingTierFactorProperty: number;
    ratingTierLiabilityCId: string;
    ratingTierPropertyCId: string;
    underwritingOverride: boolean;
    brandId: string;
}

export class Submission implements ISubmission {
    id: string;
    policyholderId: string;
    offeringId: string;
    statusCId: string;
    policyEffectiveDate: Date;
    policyExpirationDate: Date;
    currentlyInsured: boolean;
    yearEstablished: number;
    businessTypeCId: string;
    officersCovered: boolean;
    payrollIncludesOfficers: boolean;
    independentContractorsUsageCId: string;
    leasedEmployeeUsageCId: string;
    sicCode: number;
    classCodeCrime: string;
    retroactiveDateEpl: Date;
    fein: string;
    legalBusinessName: string;
    doingBusinessAs: string;
    ncciRiskId: string;
    controllingTaxAddressId: string;
    ownedVehicles: boolean;
    experienceModifierNcci: number;
    experienceModifierWcirb: number;
    experienceModifierDcrb: number;
    experienceModifierCaom: number;
    experienceModifierMwcia: number;
    experienceModifierNjcrib: number;
    experienceModifierNycirb: number;
    experienceModifierNcrb: number;
    experienceModifierPcrb: number;
    experienceModifierWcrb: number;
    hazardGradeUmbrellaCId: string;
    hazardGradeCyberCId: string;
    scheduleModifierDeliveryAuto: number;
    scheduleModifierLiability: number;
    scheduleModifierProperty: number;
    scheduleModifierUmbrella: number;
    scheduleModifierWorkersComp: number;
    ratingTierFactorLiability: number;
    ratingTierFactorProperty: number;
    ratingTierLiabilityCId: string;
    ratingTierPropertyCId: string;
    underwritingOverride: boolean;
    brandId: string;
}